import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {UserStateService} from '@services/frontend/user-state.service';

/** Accès réservé aux comptes avec le flag admin (indépendant du rôle métier). */
export const adminGuard: CanActivateFn = () => {
  const user = inject(UserStateService).getUser()();
  if (user?.admin) {
    return true;
  }
  return inject(Router).createUrlTree(['/dashboard']);
};
